// extracted by mini-css-extract-plugin
module.exports = {"publish":"PublishSwitch-module__publish___22oNU","formGroup":"PublishSwitch-module__formGroup___Dxg8B"};